{
  "title": "Boendesidor",
  "heading": "Logga in",
  "username": "E-post",
  "password": "Lösenord",
  "error": "Ett fel uppstod vid inloggningen",
  "submit": "Logga in",
  "forgotPasswordButtonText": "Har du glömt lösenordet?",
  "errors": {
    "loginExpired": "Inloggningen är föråldrad. Vänligen logga in på nytt.",
    "userAlreadyRegistered": "Det finns redan ett användarkonto {{email}} som kopplats till den identifierade användaren. Du kan återställa lösenordet genom funktionen ”Har du glömt lösenordet?”",
    "noTenantFound": "Det finns inga avtal kopplade till den identifierade användaren."
  }
}
